// extracted by mini-css-extract-plugin
export default {"clientMenuContainer":"ClientMenuIconStyles_clientMenuContainer__SdVoo","clientMenuIcon":"ClientMenuIconStyles_clientMenuIcon__M6uY7"};